function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#3d3735;}.cls-2{fill:#f9970b;}.cls-3{fill:#f2520a;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "SY_strap_horiz_pos");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M403.21,29l24.65.16-.05,7.39-15.42-.1-.05,8,11.54.08,0,7.17-11.55-.07-.09,15.31L403,66.88Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M444.55,67.57c-8.84-.06-15.49-6-15.43-15.58s6.94-15.43,15.74-15.38,15.6,6,15.54,15.58S453.4,67.62,444.55,67.57Zm.05-8c3.29,0,6.38-2.39,6.41-7.46s-3-7.52-6.2-7.54-6.28,2.34-6.31,7.46S441.26,59.57,444.6,59.59Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M472.82,67.31l-9.22,0,.18-30.1,9.23.06,0,5A11.24,11.24,0,0,1,482.45,37l-.06,9.77-2.54,0c-4.37,0-6.91,1.47-6.94,6.64Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M513.57,37c7.44.05,13.23,6,13.17,15.51s-6,15.5-13.37,15.45c-4.42,0-7.59-2-9.25-4.7l0,4.21-9.22-.06.25-39.91,9.22.06-.09,14.08A10.64,10.64,0,0,1,513.57,37Zm-2.81,8c-3.45,0-6.59,2.6-6.62,7.4s3.08,7.47,6.53,7.49,6.65-2.66,6.68-7.46S514.27,45.08,510.76,45.06Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M539.1,67.73l-9.22-.06.19-30.09,9.22.06,0,5a11.23,11.23,0,0,1,9.47-5.28l-.06,9.76h-2.54c-4.36,0-6.91,1.46-6.94,6.64Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M563,37.35c4.47,0,7.64,2.1,9.25,4.75l0-4.26,9.22.06L581.28,68l-9.23-.06,0-4.26a10.65,10.65,0,0,1-9.36,4.63c-7.34,0-13.18-6.12-13.12-15.62S555.58,37.31,563,37.35Zm2.64,8.06c-3.45,0-6.59,2.54-6.62,7.34s3.08,7.52,6.53,7.54,6.6-2.6,6.63-7.4S569.12,45.43,565.61,45.41Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M585.72,29.84c0-2.81,2.25-5,5.54-5s5.43,2.25,5.41,5.06-2.24,4.94-5.48,4.92S585.71,32.59,585.72,29.84Zm.82,8.09,9.22.06-.19,30.09-9.22,0Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M621.5,51.91c0-4.1-2.22-6.38-5.73-6.4S610,47.73,610,51.83l-.1,16.34-9.22,0,.19-30.1,9.22.06,0,4a11.06,11.06,0,0,1,9.14-4.26c7,0,11.57,4.82,11.52,12.91l-.11,17.58-9.17,0Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M644.56,30.21c0-2.81,2.24-5,5.53-5s5.44,2.25,5.42,5.06-2.24,4.94-5.48,4.92S644.54,33,644.56,30.21Zm.81,8.09,9.22.06-.18,30.09-9.22,0Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M680.34,52.28c0-4.1-2.22-6.38-5.73-6.41s-5.78,2.23-5.81,6.33l-.1,16.34-9.22-.05.19-30.1,9.22.06,0,4A11.06,11.06,0,0,1,678,38.18c7,0,11.57,4.82,11.52,12.91l-.11,17.58-9.17,0Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M703.62,38.67l-.21,34c0,7.82-4.44,10.43-10.69,10.39l-3.62,0,0-7.82h2.21c2,0,2.81-.73,2.83-2.51l.21-34.09Zm-10.08-8.16c0-2.8,2.24-5,5.53-5s5.43,2.25,5.41,5-2.24,5-5.48,4.93S693.52,33.26,693.54,30.51Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M738.17,69l-9.23-.06,0-4.1a11,11,0,0,1-9.15,4.37c-7,0-11.61-4.87-11.56-12.91l.11-17.58,9.16.06-.1,16.34c0,4.1,2.28,6.38,5.73,6.4S729,59.27,729,55.17l.1-16.34,9.22.06Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M752.4,69.07,743.18,69l.19-30.09,9.22.06,0,5A11.23,11.23,0,0,1,762,38.71L762,48.47h-2.53c-4.37,0-6.92,1.46-7,6.64Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M785.6,39.18l10,.07L776.42,83.51l-9.92-.06,7-15.27L761.44,39l10.3.07L778.58,58Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M411.89,114.72l-9.22-.06.19-30.1,9.22.06,0,5a11.22,11.22,0,0,1,9.48-5.28l-.07,9.76h-2.53c-4.37,0-6.91,1.46-6.95,6.64Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M437.51,115.31c-8.85,0-15.17-6-15.11-15.57s6.35-15.44,15.31-15.39c8.79.06,15,5.92,14.89,15.09a23,23,0,0,1-.17,2.7L431.55,102c.3,4,2.72,5.79,5.68,5.81a4.9,4.9,0,0,0,4.82-2.88l9.82.06C450.38,110.86,445,115.36,437.51,115.31Zm-5.87-18.43,11.54.07c0-3.29-2.55-5.19-5.63-5.21A5.7,5.7,0,0,0,431.64,96.88Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M469.21,84.55c7.55,0,12.86,4.23,14.38,11.42l-9.82-.06A4.76,4.76,0,0,0,469,92.42c-3.29,0-5.57,2.56-5.6,7.57s2.22,7.62,5.51,7.64a4.67,4.67,0,0,0,4.82-3.42l9.82.06c-1.61,7-7,11.29-14.53,11.24-8.85-.06-15.06-6-15-15.58S460.36,84.49,469.21,84.55Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M500.45,115.71c-8.85-.06-15.49-6-15.43-15.58S492,84.69,500.75,84.75s15.61,6,15.55,15.58S509.3,115.76,500.45,115.71Zm.05-8c3.29,0,6.38-2.38,6.41-7.45s-3-7.52-6.21-7.54-6.27,2.33-6.3,7.46S497.16,107.7,500.5,107.72Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M526.69,85.34l6.4,21.51,6.66-21.43,9.81.07-10.87,30-11.38-.07L516.82,85.28Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M565,116.11c-8.85,0-15.17-6-15.11-15.57s6.35-15.44,15.3-15.39c8.8.06,15,5.92,14.91,15.09a23.16,23.16,0,0,1-.19,2.7l-20.87-.13c.3,3.94,2.72,5.78,5.68,5.8a4.9,4.9,0,0,0,4.82-2.88l9.82.06C577.87,111.66,572.51,116.16,565,116.11Zm-5.87-18.43,11.54.07c0-3.28-2.56-5.19-5.63-5.21A5.7,5.7,0,0,0,559.14,97.68Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M592.46,115.85l-9.22,0,.19-30.1,9.22.06,0,5a11.24,11.24,0,0,1,9.47-5.28L602,95.25H599.5c-4.37,0-6.92,1.47-7,6.64Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M625.66,86l10,.07L616.48,130.3l-9.92-.07,7-15.27L601.5,85.81l10.3.07,6.84,18.86Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M642,162.55c-4.35-1.75-8.5-3.12-11.93-4.7-2.36-.84,2.76-.33.6-1.74-2.37-.85-7.11-2.53-9.55-3.17-2.14-1.6,3-1,.82-2.64s-12-4-14.35-5.16c-3.63-1.21-2.34-1.13.79-.51s8,2.12,11.67,3.19c-2.26-1.32,4.89,1.46,5.07.87.37-1.17.78-2.33-8.84-6.16-2.38-1,.34-1.18.52-1.76l-5.61-1.68-5.74-1.42-11.6-2.84L582,132.54c-2-.37-4-.78-6-1.1l-6-.84a294.34,294.34,0,0,0-47.71-3.07c-12.91.39-27.17.55-41.34,2.11-3.54.38-7.09.67-10.59,1.14L460,132.47c-3.42.55-6.79,1.13-10,2s-6.46,1.58-9.55,2.39c-3.78.86-8.76,2.23-13.47,3.4-2.34.62-4.6,1.25-6.55,1.91a21.41,21.41,0,0,0-4.64,2.32c2.44-.85,4.87-1.72,7.37-2.36l-5.42,2.1c-1.81.68-3.64,1.29-5.48,1.88l-5.53,1.77a40.25,40.25,0,0,0-5.41,2.08c.16.42.26.69-.6,1.31a1,1,0,0,1,0,.24,149.7,149.7,0,0,1,15.56-5.57l.29.88c-4.72,2-12.27,3.71-16.83,6.12.11.29.34.86.45,1.14,0,.06-.08.16-.26.28a.78.78,0,0,1,.05.14l5-2.08.44,1.15c.11.29-2.23,1.25-4.57,2.22.22.57-1.88,2.1.56,1.43,2.34-.95,4.63-2,7-2.75a41.78,41.78,0,0,0-6,2.79,44.29,44.29,0,0,0-4.08,2.46c-2.11,1.45-3,2.49-2.84,2.92,2.19-1.24,2.54-.39,4.73-1.62-6.57,3.7-12.9,7.63-3.64,4.15,39.87-16.72,84-24.52,128-23.67A350.66,350.66,0,0,1,644,165c0-.47.12-1,.21-1.45a.32.32,0,0,0,0-.09Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M1,52.42H14.36V73.15A36.57,36.57,0,0,1,1,68.93ZM18.52,73.75v-12a32.73,32.73,0,0,0,5.16.48c6.3,0,12-2.65,12-8.92,0-5.9-5.54-7.95-13.73-10.24C6.3,39,0,33,0,21.09,0,7.83,11.09,0,25.57,0A28.39,28.39,0,0,1,29.1.24V11.93a30.06,30.06,0,0,0-3.4-.24c-6.42,0-10.33,3.25-10.33,8.19,0,5.67,4.66,7.72,14,10.13C45,34.1,51.15,40.37,51.15,52.54c0,14.82-13,21.45-28.6,21.45C21.17,74,19.78,73.87,18.52,73.75ZM33.26,20.49V.72A37.39,37.39,0,0,1,46.74,5.06V20.49Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M91,21.93,75.59,61H84V72.79h-30V61H60.1L83.4,3.5ZM87.82,39.77H98.4L102.93,51H83.66ZM102.93,1.21,128.26,61h5.92V72.79H102.81V61h8.44L86.55,1.21Z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M163.79,33.62,159.13,61h7.31V72.79H137.33V61h7.31L152,16.27h3.78Zm21,39.17L158.62,13H144.26V1.21h27.47l26.2,62.9L195,72.79ZM192,40.37,207.63,1.21h26.46V13h-15l-19,45.67Zm30-24.1h4.41L233.71,61H241V72.79H211.54V61h7.3L214.18,34.1Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M246.06,1.21h22.68V72.79H246.06V61h7.18V13h-7.18ZM289,13H272.9V1.21h29.6v21.2H289ZM272.9,42.78V31h16.5V42.78Zm0,30V61h16.88V51.58h13.48V72.79Z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M58.68,163.36H69.91v15.71H26.83V163.36H38.07V144.28L9.24,99.55H.86V83.84h41.9V99.55H32l26.65,42.16ZM52.14,122,66.89,99.55H56V83.84H96.06V99.55H87.68L62.2,137.06Z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M267.53,164.16v16.19c-4,.16-7.88.32-11.4.32-23.63,0-43.41-8-43.41-34.79V99.55h-9.55V83.84h39.72V99.55h-9.55v42.32c0,17.16,8.54,22.61,22.79,22.61C260.32,164.48,263.84,164.32,267.53,164.16Zm-4.19-64.61V83.84h39.89V99.55h-9.55v61.72l9.55-1.6v15.87c-7.71,2.08-19.11,3.69-30.17,4.33V99.55Z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M115.1,128.56c1.59-15.71,15.43-28,32.27-28s30.68,12.28,32.27,28h20C198,102.31,175.23,81.5,147.37,81.5s-50.62,20.81-52.26,47.06Zm64.57,5.61c-1.37,15.92-15.3,28.43-32.3,28.43s-30.93-12.51-32.3-28.43h-20c1.4,26.46,24.28,47.5,52.29,47.5s50.89-21,52.29-47.5Z"
});

var SvgSameYouLogo = function SvgSameYouLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 795.58 181.67",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSameYouLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sameYouLogo.0dd24e19.svg";
export { ForwardRef as ReactComponent };